<template>
  <div>
    <div class="event-label-title">
      <label class="event-title-label-box font14 mr16">
        <p><span style="font-size: 0.8em">响应组件：</span>{{ innerElementLabel }}</p></label
      >
    </div>
    <div class="set-components-show">
      <p class="play_btn"><span class="icon-portal-play" @click="playAnimate"></span></p>
      <cx-select title="显隐选择" class="mt8" :value.sync="changeToProxy" :selectOptions="showTypes" />
      <cx-select title="动画类型" class="mt8" :value.sync="actionProxy" :selectOptions="actionTypesProxy" />
      <cx-select title="动画方向" class="mt8" :value.sync="actionDesProxy" :selectOptions="actionDesTypesProxy" />
      <slider-and-input class="mt8" :value.sync="durationProxy" title="持续时间" :sliderMax="100" suffix="s" />
      <cx-select title="重复次数" class="mt8" :value.sync="repeatProxy" :selectOptions="repeatTypes" />
      <div class="mt16 save_box padding0">
        <div @click="saveEvent" class="save_edit">保存交互</div>
      </div>
    </div>
  </div>
</template>

<script>
import { showTypes, actionTypes, actionDesTypes, repeatTypes } from "./utils/componentShow"
export default {
  props: {
    changeTo: String,
    action: String,
    actionDes: String,
    innerElementLabel: String,
    duration: Number,
    repeat: String,
    responseRectIds: Object
  },
  data() {
    return {
      showTypes,
      repeatTypes
    }
  },
  computed: {
    changeToProxy: {
      get() {
        return this.changeTo
      },
      set(val) {
        this.$emit("update:changeTo", val)
      }
    },
    actionProxy: {
      get() {
        return this.action
      },
      set(val) {
        this.$emit("update:action", val)
      }
    },
    actionDesProxy: {
      get() {
        console.log(this.actionDes)
        return this.actionDes
      },
      set(val) {
        this.$emit("update:actionDes", val)
      }
    },
    durationProxy: {
      get() {
        return this.duration
      },
      set(val) {
        this.$emit("update:duration", val)
      }
    },
    repeatProxy: {
      get() {
        return this.repeat
      },
      set(val) {
        this.$emit("update:repeat", val)
      }
    },
    actionTypesProxy() {
      return actionTypes.map(it => {
        const res = { ...it }
        if (this.changeTo === "In") {
          res.label = res.label + "入"
        }
        if (this.changeTo === "Out") {
          res.label = res.label + "出"
        }
        if (this.changeTo === "in") {
          res.label = res.label + "切换"
        }
        return res
      })
    },
    actionDesTypesProxy() {
      return actionDesTypes
    }
  },
  methods: {
    saveEvent() {
      console.log("sae")
      //通知主组件 完成事件绑定
      this.$emit("save", "component", "show")
    },
    playAnimate() {
      const idsStr = this.$event.getIdsByStrId({ ...this.responseRectIds })
      const rootEl = document.getElementsByClassName(idsStr)[0]
      const el = rootEl.getElementsByClassName("rect")[0]
      const elClassList = el.classList || []
      for (let i = 0; i < elClassList.length; i++) {
        if (elClassList[i].includes("animate")) elClassList.remove(elClassList[i])
      }
      const animateType = this.changeTo === "exchange" ? "In" : this.changeTo
      const animateClass = "animate__" + this.actionProxy + animateType + this.actionDes
      rootEl.style.setProperty("--animate-duration", this.duration + "s")
      const repeatClass =
        this.repeat === "0"
          ? ""
          : this.repeat === "infinite"
          ? "animate__" + this.repeat
          : "animate__repeat-" + this.repeat
      elClassList.add("animate__animated", animateClass)
      elClassList.add("animateClass")
      repeatClass.length && elClassList.add(repeatClass)
      setTimeout(() => {
        elClassList.remove("animate__animated", animateClass)
        repeatClass.length && elClassList.remove(repeatClass)
      }, this.duration * 1000 * (this.repeat === "infinite" ? 6 : Number(this.repeat) + 1))
    }
  }
}
</script>
<style scoped>
.set-components-show {
  padding: 16px 24px;
}
.play_btn {
  text-align: right;
}
.play_btn span:hover {
  cursor: pointer;
}
</style>
